var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"v-chip-small",attrs:{"dark":"","color":_vm.active ? 'deep-red' : 'gray'}},[_vm._v("Call")])}
var staticRenderFns = []

export { render, staticRenderFns }